import React, { Fragment, useEffect, useState } from 'react';
import { Button, Row } from '@digital/ui';
import { Modal } from 'antd';
import './custom.css';
import { EditandoStateInfo, ajustarStepOnReloadState, dadosGeraisState, editandoState, modalAcoesIdState, reloadVendorListState, reloadWidgetTimelineState, stepState } from '../atoms';
import { useRecoilState, useRecoilValue, useSetRecoilState } from 'recoil';
import { Space, Visibility } from '@app/components';
import { limparAcoesProposta } from '@app/api/sas/sasProposta';
import { EGuidFluxoProcessoEtapa } from '@app/enums/EGuidFluxoProcessoEtapa';
import { isObjNotEmpty } from '@app/helpers/objHelper';
import { getLoggedId } from '@app/helpers';

interface ModalAcoesGeraisProps {
    child: React.ReactNode[];
    id: string;
    status: string;
    ehPropostaAtiva: boolean;
}

const ModalAcoesGerais = ({ child, id, status, ehPropostaAtiva }: ModalAcoesGeraisProps) => {

    const [clicavel, setClicavel] = useState(true);
    const [exibirLimpar, setExibirLimpar] = useState(true);
    const [exibirEditar, setExibirEditar] = useState(true);
    const [ehComprador, setEhComprador] = useState(false);
    const [modalAcoesId, setModalAcoesId] = useRecoilState(modalAcoesIdState);
    const [editando, setEditando] = useRecoilState(editandoState);
    const step = useRecoilValue(stepState);
    const dadosGerais = useRecoilValue(dadosGeraisState);
    const [loggedId] = useState(getLoggedId() || "");

    const setReloadVendorList = useSetRecoilState(reloadVendorListState);
    const setReloadWidgetTimeline = useSetRecoilState(reloadWidgetTimelineState);

    const setAjustarStepOnReload = useSetRecoilState(ajustarStepOnReloadState);

    const stepsOndeNaoLimpar = [
        EGuidFluxoProcessoEtapa.DefinicaoVendorList,
        EGuidFluxoProcessoEtapa.AnalisePropostasComerciaisCadastroRodadasNegociacoes
    ];

    const stepsOndeEditar = [
        EGuidFluxoProcessoEtapa.AceiteOuDeclinio,
        EGuidFluxoProcessoEtapa.EsclarecimentosTecnicosSolicitados,
        EGuidFluxoProcessoEtapa.ParecerTecnico,
        EGuidFluxoProcessoEtapa.SolicitacaoCONFIDE,
        EGuidFluxoProcessoEtapa.RecebimentoFormularioDDIProponentesEnvioParaDPC,
        EGuidFluxoProcessoEtapa.CadastroParecerDoDPCQuantoADDI,
        EGuidFluxoProcessoEtapa.SolicitacaoAvaliacaoFinanceira,
        EGuidFluxoProcessoEtapa.CadastroResultadoAvaliacaoFinanceira,
        EGuidFluxoProcessoEtapa.RecebimentoPropostaComercial,
        EGuidFluxoProcessoEtapa.FluxoGenericoRodadaNegociacao,
        EGuidFluxoProcessoEtapa.EnvioNegociacaoMinutaContratual,
        EGuidFluxoProcessoEtapa.SolicitacaoChancelaGJMinuta,
    ];

    useEffect(() => {
        if (child && child.length > 0) {
            setClicavel(true);
        } else {
            setClicavel(false);
        }
    }, [child]);

    useEffect(() => {
        if (isObjNotEmpty(dadosGerais)) {
            setEhComprador(dadosGerais.compradorId == loggedId);
        }
    }, [dadosGerais]);

    useEffect(() => {
        if (status === 'Concluído' && ehComprador) {
            if (isObjNotEmpty(step) && 'fluxoEtapaId' in step && stepsOndeNaoLimpar.includes(step.fluxoEtapaId)) {
                setExibirLimpar(false);
            } else {
                setExibirLimpar(true);
            }

            if (isObjNotEmpty(step) && 'fluxoEtapaId' in step && stepsOndeEditar.includes(step.fluxoEtapaId)) {
                setExibirEditar(true);
            } else {
                setExibirEditar(false);
            }
        } else {
            setExibirLimpar(false);
            setExibirEditar(false);
        }
    }, [clicavel, ehComprador]);

    useEffect(() => {
        if (modalAcoesId === '') {
            setEditando({} as EditandoStateInfo);
        }
    }, [modalAcoesId]);

    const onCancel = () => {
        setModalAcoesId('');
        setEditando({} as EditandoStateInfo);
    };

    const openModal = () => {
        console.log('aeaeae', ehPropostaAtiva, clicavel, exibirLimpar, exibirEditar);
        if (ehPropostaAtiva && (clicavel || exibirLimpar || exibirEditar)) {
            setAjustarStepOnReload(false);
            setModalAcoesId(id);
        }
    };

    const onClickLimpar = () => {
        Modal.confirm({
            title: 'Limpar',
            content: 'Confirma que todas as ações dessa etapa relativa ao proponente serão desfeitas?',
            okText: 'Sim',
            cancelText: 'Não',
            onOk: () => {
                limparAcoesProposta(id, step.ordemCompraFluxoProcessoId, step.ordemCompraRodadaNegociacaoId)
                    .then(data => {
                        if (data) {
                            setReloadWidgetTimeline((v: boolean) => !v);
                            setReloadVendorList((v: boolean) => !v);
                            onCancel();
                        }
                    });
            },
            onCancel: onCancel
        });
    };

    const onClickEditar = () => {
        setEditando({
            sasPropostaId: id,
            ordemCompraFluxoProcessoId: step.ordemCompraFluxoProcessoId,
            ordemCompraRodadaNegociacaoId: step.ordemCompraRodadaNegociacaoId,
        });
    };

    return (
        <Visibility>
            <Button
                className={`button-modal-acoes-gerais ${(status === 'Concluído') || (!clicavel && !exibirLimpar && !exibirEditar) ? 'button-modal-acoes-gerais-disabled' : ''}`}
                disabled={step.fluxoEtapaId == EGuidFluxoProcessoEtapa.SolicitacaoDDI/*!clicavel*/}
                title='Executar'
                onClick={() => openModal()}
            />

            <Modal
                visible={modalAcoesId === id}
                onCancel={onCancel}
                width="300px"
                title="Ações"
                className='modal-acoes-gerais'
                footer={
                    <Visibility visible={exibirLimpar || exibirEditar} >
                        <Row style={{ width: '100%', display: 'flex', justifyContent: 'space-between' }} >
                            <Visibility visible={exibirLimpar}>
                                <Button type='link' title='LIMPAR' onClick={onClickLimpar} />
                            </Visibility>
                            <Visibility visible={exibirEditar}>
                                <Button type='link' title='EDITAR' onClick={onClickEditar} />
                            </Visibility>
                            <Button type='link' title='CANCELAR' onClick={onCancel} />
                        </Row>
                    </Visibility>
                }
            >
                <Row>
                    {child && child.length > 0 && (
                        <div className='modal-acoes-gerais-buttons' >
                            <Row style={{ display: 'flex' }} key="modal-acoes-gerais-buttons_row">
                                {
                                    child.map((child: any, index: number) => {
                                        return (
                                            <Fragment key={index.toString()}>
                                                <Space ml={4} />
                                                {child}
                                            </Fragment>
                                        );
                                    })
                                }
                            </Row>
                        </div>
                    )}
                </Row>
            </Modal >

        </Visibility>
    );
};

export default ModalAcoesGerais;